import script from "./ClientsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientsBlockPanelList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientsBlockPanelList.vue?vue&type=style&index=0&id=15d73548&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d73548"]])

export default __exports__